import produce from 'immer';
import { ActivityRun } from '@robocorp/robocloud-orchestrator-interface';
import { combineReducers } from 'redux';
import { ActivityRunActionType, ActivityRunAction } from '../../actions/activityRunActions';

interface ActivityRunState {
  byId: Record<string, ActivityRun>;
  allIds: string[];
  idsByActivityId: Record<string, string[]>;
  idsByProcessRunId: Record<string, string[]>;
}

export const initialState: ActivityRunState = {
  byId: {},
  allIds: [],
  idsByActivityId: {},
  idsByProcessRunId: {},
};

const byId = (state = initialState.byId, action: ActivityRunAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ActivityRunActionType.GET_ACTIVITY_RUNS:
        return {};
      case ActivityRunActionType.SET_ACTIVITY_RUN: {
        draft[action.activityRun.id] = action.activityRun;
        break;
      }
      case ActivityRunActionType.GET_ACTIVITY_RUN_OK: {
        draft[action.data.id] = action.data;
        break;
      }
      case ActivityRunActionType.GET_ACTIVITY_RUNS_OK: {
        action.data.forEach((aRun) => {
          draft[aRun.id] = aRun;
        });

        break;
      }
      default:
        return state;
    }
  });

const allIds = (state = initialState.allIds, action: ActivityRunAction) => {
  switch (action.type) {
    case ActivityRunActionType.GET_ACTIVITY_RUNS:
      return [];
    case ActivityRunActionType.GET_ACTIVITY_RUNS_OK:
      return action.data.map((aRun) => aRun.id);
    case ActivityRunActionType.GET_ACTIVITY_RUN_OK:
      return [action.data.id];
    case ActivityRunActionType.SET_ACTIVITY_RUN:
      return state.includes(action.activityRun.id) ? state : [...state, action.activityRun.id];
    default:
      return state;
  }
};

const idsByActivityId = (state = initialState.idsByActivityId, action: ActivityRunAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ActivityRunActionType.GET_ACTIVITY_RUNS:
        return {};
      case ActivityRunActionType.GET_ACTIVITY_RUN_OK: {
        draft[action.data.activityId] = [action.activityRunId];
        break;
      }
      case ActivityRunActionType.GET_ACTIVITY_RUNS_OK: {
        action.data.forEach((aRun) => {
          if (!draft[aRun.activityId]) draft[aRun.activityId] = [];
          if (!draft[aRun.activityId].includes(aRun.id)) draft[aRun.activityId].push(aRun.id);
        });

        break;
      }
      case ActivityRunActionType.SET_ACTIVITY_RUN: {
        if (!draft[action.activityRun.activityId]) draft[action.activityRun.activityId] = [];
        if (!draft[action.activityRun.activityId].includes(action.activityRun.id))
          draft[action.activityRun.activityId].push(action.activityRun.id);
        break;
      }
      default:
        return state;
    }
  });

const idsByProcessRunId = (state = initialState.idsByProcessRunId, action: ActivityRunAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ActivityRunActionType.GET_ACTIVITY_RUNS:
        return {};
      case ActivityRunActionType.GET_ACTIVITY_RUN_OK: {
        if (!draft[action.data.processRunId]) draft[action.data.processRunId] = [];
        if (!draft[action.data.processRunId].includes(action.activityRunId)) {
          draft[action.data.processRunId].push(action.activityRunId);
        }
        break;
      }
      case ActivityRunActionType.GET_ACTIVITY_RUNS_OK: {
        action.data.forEach((aRun) => {
          if (!draft[aRun.processRunId]) draft[aRun.processRunId] = [];
          if (!draft[aRun.processRunId].includes(aRun.id)) draft[aRun.processRunId].push(aRun.id);
        });

        break;
      }
      case ActivityRunActionType.SET_ACTIVITY_RUN: {
        if (!draft[action.activityRun.processRunId]) draft[action.activityRun.processRunId] = [];
        if (!draft[action.activityRun.processRunId].includes(action.activityRun.id))
          draft[action.activityRun.processRunId].push(action.activityRun.id);
        break;
      }
      default:
        return state;
    }
  });

export default combineReducers({
  byId,
  allIds,
  idsByActivityId,
  idsByProcessRunId,
});
